import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class LoggingService {
  constructor() {}

  public info(...args: any[]) {
    if (!environment.production) {
      console.log(...args);
    }
  }

  public error(...args: any[]) {
    console.error(...args);
  }

  public warn(...args: any[]) {
    console.warn(...args);
  }
}
